import { ApiBearerToken } from "../../../requests/getBearerToken";
import { ApiPacvueToken } from "../../../requests/refreshPacvueToken";
import { getCurrentAccountId } from "../../helpers/bearerToken";
import { getPacvueTokenFromLocalStorage, savePacvueTokenToLocalStorage, } from "../../helpers/pacvueTokenStore";
const REFRESH_INTERVAL = 6e4;
/**
 * there could be muliple requests made at a time,
 * no need to refresh token for every requests.
 * this debounced function will cache the refresh token request/response
 * and shared among the concurrent API requests.
 */
export const refreshPacvueTokenDebounced = debounceRefreshToken(REFRESH_INTERVAL);
function debounceRefreshToken(delay) {
    let lastRefreshTime = 0;
    let cachedResponse;
    return function () {
        if (lastRefreshTime + delay < Date.now()) {
            cachedResponse = refreshPacvueToken();
            lastRefreshTime = Date.now();
        }
        return cachedResponse;
    };
}
async function refreshPacvueToken() {
    try {
        const accountId = getCurrentAccountId();
        if (!accountId)
            return false;
        return ((await refreshPacvueTokenFromPacvueApi(accountId)) ||
            (await refreshPacvueTokenFromSiteTokenApi(accountId)));
    }
    catch {
        return false;
    }
}
async function refreshPacvueTokenFromPacvueApi(accountId) {
    try {
        const currentRefreshToken = await getCurrentRefreshToken(accountId);
        if (!currentRefreshToken)
            return false;
        const { accessToken, refreshToken, expiresIn } = await ApiPacvueToken.refreshToken(currentRefreshToken);
        await savePacvueTokenToLocalStorage(accountId, {
            pacvueToken: accessToken,
            pacvueRefreshToken: refreshToken,
            pacvueTokenExpiresIn: expiresIn,
            pacvueTokenCreatedAt: Date.now(),
        });
        return true;
    }
    catch {
        return false;
    }
}
async function refreshPacvueTokenFromSiteTokenApi(accountId) {
    try {
        const result = await ApiBearerToken.get(accountId);
        const { pacvueToken, pacvueRefreshToken, pacvueTokenExpiresIn } = result.data;
        if (pacvueToken && pacvueRefreshToken && pacvueTokenExpiresIn) {
            await savePacvueTokenToLocalStorage(accountId, {
                pacvueToken,
                pacvueRefreshToken,
                pacvueTokenExpiresIn,
                pacvueTokenCreatedAt: Date.now(),
            });
        }
        return true;
    }
    catch {
        return false;
    }
}
async function getCurrentRefreshToken(accountId) {
    if (!accountId) {
        return;
    }
    const token = await getPacvueTokenFromLocalStorage(accountId);
    if (!token) {
        return;
    }
    return token.pacvueRefreshToken;
}
